export const shouldRenderClientHistoryEmptyState = ({ hasRows, isLoading, error }) => (
  !hasRows && !isLoading && !error
);
